const TYPES = {
    LawyerService: Symbol.for("LawyerService"),
};

export { TYPES };